export const questriOrange = {
  main: '#FF6B35',
  hover: '#FF5520',
  active: '#E54D1C',
  text: '#FFFFFF',
  separator: 'rgba(255, 255, 255, 0.3)',
  focus: 'rgba(255, 107, 53, 0.4)',
};

export const getQuestriPrimaryButtonSx = (options = {}) => {
  const {
    isSplitRight = false,
    isOpen = false,
  } = options;
  let baseColor = questriOrange.main;
  if (isSplitRight && isOpen) {
    baseColor = questriOrange.hover;
  }

  const styles = {
    background: `${baseColor} !important`,
    backgroundColor: `${baseColor} !important`,
    border: `1px solid ${questriOrange.main} !important`,
    boxShadow: 'none !important',
    color: `${questriOrange.text} !important`,
    '&:hover': {
      background: `${questriOrange.hover} !important`,
      backgroundColor: `${questriOrange.hover} !important`,
      boxShadow: 'none !important',
    },
    '&:active': {
      background: `${questriOrange.active} !important`,
      backgroundColor: `${questriOrange.active} !important`,
      boxShadow: 'none !important',
    },
    '&:focus-visible': {
      boxShadow: 'none !important',
      outline: `3px solid ${questriOrange.focus}`,
      outlineOffset: 2,
    },
  };
  if (isSplitRight) {
    styles.borderLeft = `1px solid ${questriOrange.separator} !important`;
  }

  return styles;
};
